var _image;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlideshow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    xmlSpace: "preserve",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAjUlEQVR4nO2SMQqDQBREXxeLkHOIrcdJH08Ta3Mb7XOSkCakd0NghAUt80XDPPjsLFvM+7BgzJwUPPsR+DUWSBbAAlgACyQLsHWBtNJsV2AXnLXFPdtoyt+3cAaVXTKBRmcfXV4CI/AGTpnAEXgpV5ECrUo63fNPdVO+RpUfgIdK6gWBWvkJFFES5v/4APgzutNKYo3xAAAAAElFTkSuQmCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideshow);
export default __webpack_public_path__ + "static/media/slideshow.7f9a34c76ef43a24ec2cc1d1f0ff2504.svg";
export { ForwardRef as ReactComponent };